import { render, staticRenderFns } from "./ClinicAppointmentDetail.vue?vue&type=template&id=47d7ba79&scoped=true"
import script from "./ClinicAppointmentDetail.vue?vue&type=script&lang=js"
export * from "./ClinicAppointmentDetail.vue?vue&type=script&lang=js"
import style0 from "./ClinicAppointmentDetail.vue?vue&type=style&index=0&id=47d7ba79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d7ba79",
  null
  
)

export default component.exports